"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const EmailInput_1 = __importDefault(require("./EmailInput"));
/** This email input must be nested in react-hook-form */
const Email = ({ required = true, control, ...rest }) => ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "email", render: ({ field, fieldState }) => {
        const { ref: inputRef, ...fieldProps } = field;
        return ((0, jsx_runtime_1.jsx)(EmailInput_1.default, { error: !!fieldState.error, fieldProps: fieldProps, inputRef: inputRef, ...rest }));
    }, rules: {
        required,
        pattern: /\S+@\S+\.\S+/,
    } }));
exports.default = Email;
//# sourceMappingURL=index.js.map